

import React from 'react';
import './Movie.css';

import { Link } from "react-router-dom";
const Movie = (props) => {


    //console.log(props.mov);
const image_api = "https://image.tmdb.org/t/p/w500";

const Setvoteclass = (vote) => {

       if(vote >= 8){
           return 'green'
       } 

       else if (vote >= 6){
           return "orange"
       }

       else{

        return "red"
       }

};

const {title , poster_path , overview , vote_average, id }= props.mov;




    return (
        <div className="movie">

            {/* <Link to={`/movie/${id}`} mov={props.mov}> */}

            <Link to={{ pathname: `/movie/${id}`, state: { movieProps: props.mov } }}>


            <div className="movie-header">

                
            <img src={ poster_path ? (image_api + poster_path) :
                'https://images.unsplash.com/photo-1440404653325-ab127d49abc1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80'} alt={title} />
            </div>
            <div className="movie-info">
            <h3 className="movie-card-title">{title}</h3>
            <span className={`tag ${Setvoteclass(vote_average)}`}>{vote_average}</span>

            </div>
           

           <div className="movie-overview">
               <h2>Overview</h2>
               <p>{overview}</p>
           </div>
            </Link>
        </div>
    );
};

export default Movie;